import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["iframe", "container", "desktopButton", "mobileButton"]

  connect: ->
    @showMobile()

  showDesktop: ->
    @containerTarget.classList.remove('responsive-preview__container--mobile')
    @containerTarget.classList.add('responsive-preview__container--desktop')
    
    @desktopButtonTarget.classList.add('active')
    
    @mobileButtonTarget.classList.remove('active')

  showMobile: ->
    @containerTarget.classList.remove('responsive-preview__container--desktop')
    @containerTarget.classList.add('responsive-preview__container--mobile')
    
    @mobileButtonTarget.classList.add('active')
    
    @desktopButtonTarget.classList.remove('active')